import { useContext } from 'react';

import RoutesContext from 'src/contexts/Routes';

const useRoutes = () => useContext(RoutesContext);

export default useRoutes;
